jQuery(document).ready(function($) {

	
	$(window).scroll(function() {
		if ($(window).scrollTop() > 15) {
			$('body').addClass('scrolled');
		} else {
			$('body').removeClass('scrolled');
		}
	});

	
	var imageResizeTimeout = false;
	function resizeImages() {
		$('.image-fill-wrapper').each(function() {
			var childImg = $(this).find('img');
			childImg.css('display', 'block');
			if ($(this).hasClass('small-images')) {
				childImg.css('width', '100%');
				childImg.css('height', 'auto');
			}  else if ($(window).width()<=400) {
				childImg.css('width', 'auto');
				childImg.css('height', 'auto');
			}  else if (childImg.width()<$(this).width()) {
				childImg.css('width', '100%');
				childImg.css('height', 'auto');
			}  else {
				childImg.css('width', 'auto');
				childImg.css('height', '100%');
			}
		});
	}
	$(window).resize(function() {
		clearTimeout(imageResizeTimeout);
		imageResizeTimeout = setTimeout(resizeImages, 200);
	});
	//resizeImages();
	$(window).trigger('resize');
	window.setTimeout(function() {
		$(window).trigger('resize');
	}, 1200);
	
});

function scrollTo() {
	document.querySelectorAll('.scrollTo').forEach( e => {
		let selector = e.attributes['data-scrollTo'].nodeValue;
		e.addEventListener('click', e => {
			e.preventDefault();
			let target = document.querySelector(selector).offsetTop;
			if (target) {
				$('html, body').animate({
					scrollTop: target
				}, 500);
			}
		});
	})
}
jQuery(document).ready(function($) {
	scrollTo();
});